import { Box, Divider } from "@mui/material";
import { TransForm } from "../common/TransForm/Index";
import UserFormInputs from "../common/jsons/formConfigs/userFormConfig";
import { PageTitle } from "../common/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import { useCallback, useEffect } from "react";
import axios from "axios";
import { base_url } from '../backendurl/url'
import { useState } from "react";
import ModalPopUp from "../common/TransForm/ModalPopUp";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { Notification } from "../common/Notification";

export const UserForm = ({ mode }) => {
  const { selectedUser } = useSelector(
    (state) => state
  );

  const [popup, setPopup] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_uuid } = useParams("user_uuid");
  const [loading, setLoading] = useState(false)
  const [notification, setnotification] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [userData, setUserdata] = useState()

  // State for password visibility toggles
  const [eyeOpen, setEyeOpen] = useState(false);
  const [confirmEyeOpen, setConfirmEyeOpen] = useState(false);

  // Add form errors state to handle validation errors without resetting form
  const [formErrors, setFormErrors] = useState({});
  
  // Add current form values state to preserve data during validation
  const [currentFormValues, setCurrentFormValues] = useState({});

  const [saveBtnText, setSaveBtnText] = useState({
    title: 'Do you want to Add New Admin ?',
    content: 'Are you sure, you want to create & save a new Admin with given details.',
    btnText: 'yes , Save'
  })

  // Function to extract error messages from the error response
  const extractErrorMessages = (errorResponse) => {
    try {
      console.log(errorResponse, "errorResponse")
      if (errorResponse?.data?.errors && Array.isArray(errorResponse?.data?.errors)) {
        const errorMessages = [];
        
        errorResponse.data?.errors.forEach(errorGroup => {
          console.log(errorGroup, "errorGroup")
          if (Array.isArray(errorGroup)) {
            errorGroup.forEach(([fieldName, messages]) => {
              if (Array.isArray(messages)) {
                messages.forEach(message => {
                  errorMessages.push(`${fieldName}: ${message}`);
                });
              }
            });
          }
        });
        
        return errorMessages.join('\n');
      }
      
      if (errorResponse?.message) {
        return errorResponse.message;
      }
      
      return 'An error occurred while processing your request.';
    } catch (e) {
      return 'An unexpected error occurred.';
    }
  };

  // Updated validation function that doesn't reset form data
  const validatePasswords = (data) => {
    // Store current form values before validation
    setCurrentFormValues(data);
    
    if (mode === 'new' && data.password !== data.confirm_password) {
      // Set form-level error without affecting form data
      setFormErrors({
        confirm_password: 'Passwords do not match'
      });
      return false;
    }
    
    // Clear any existing password errors if validation passes
    setFormErrors({});
    return true;
  };

  // Updated onSubmit function
  const onSubmit = async (data) => {
    // Always preserve the current form data
    setCurrentFormValues(data);
    
    // Validate passwords before proceeding
    if (!validatePasswords(data)) {
      // Return early but keep all form values intact
      return;
    }

    if (mode === "edit") {
      setSaveBtnText({
        title: 'Save Changes ?',
        content: 'Are you sure, you want to save the changes made on Admin',
        btnText: 'yes , Save'
      })
      setUserdata(data)
      setPopup(true)

    } else if (mode === "view") {
      navigate(`/users/edit/${user_uuid}`);
    } else {
      setSaveBtnText({
        title: 'Confirm the action ?',
        content: 'Are you sure, you want to Add New Admin',
        btnText: 'yes , Save'
      })
      setUserdata(data)
      setPopup(true)
    }
  };

  const SubmitUser = async () => {
    try{
      setLoading(true);
      
      if (mode == 'edit') {
        const response = await axios.put(`${base_url}/api/accounts/user/${user_uuid}`, userData, Config)
        if (response?.data?.status == 'Success') {
          navigate(`/users`);
        }
      } else {
        const submitData = { ...userData };
        delete submitData?.Add;
        delete submitData?.id;
        delete submitData?.is_active;
        
        const response = await axios.post(`${base_url}/api/accounts/user/create`, submitData, Config)
        if (response?.data?.status == 'Success') {
          navigate(`/users`);
        }
      }

      setPopup(false)
      setLoading(false);
    }
    catch(error){
      setLoading(false);
      setPopup(false);
      
      if (error?.response?.status === 422 && error?.response?.data) {
        const errorMsg = extractErrorMessages(error.response.data);
        setErrorMessage(errorMsg);
        setnotification(true);
      } else {
        RefreshToken(error, setErrorMessage, setnotification);
      }
    }
  }

  const getSelectedUser = useCallback(async () => {
    try{
      if (mode != 'new') {
        setLoading(true)
        const response = await axios.get(`${base_url}/api/accounts/user/${user_uuid}`, Config);

        if (response?.status == 200) {
          delete response?.data?.id
          setUserdata(response?.data)
          // Also set current form values to preserve data
          setCurrentFormValues(response?.data)
        }

        setLoading(false)
      }
    }
    catch(error){
      setLoading(false);
      RefreshToken(error, setErrorMessage, setnotification)
    }
  }, [selectedUser, user_uuid]);

  // Function to handle form data changes and preserve values
  const handleFormDataChange = (newFormData, key, value) => {
    // Always update current form values
    setCurrentFormValues(newFormData);
    
    // Clear field-specific errors when user starts typing
    if (formErrors[key]) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[key];
        return newErrors;
      });
    }
  };

  useEffect(() => {
    getSelectedUser();
  }, []);

  // Use currentFormValues if available, otherwise fallback to userData
  const formDataToUse = Object.keys(currentFormValues).length > 0 ? currentFormValues : userData;
console.log(mode,"mode")
  return (
    <Box>
      <Box display="flex" sx={{ px: 6, pt: 3 }} alignContent="center">
        <PageTitle pageTitle={mode == 'new' ? 'Add New Admin' : 'Admin Details'} backBtn />
      </Box>

      <TransForm
        submitAction={onSubmit}
        data={formDataToUse} // Use preserved form data
        mode={mode}
        formInputs={UserFormInputs({ 
          mode, 
          eyeOpen, 
          confirmEyeOpen,
          toggleEye: () => setEyeOpen(!eyeOpen),
          toggleConfirmEye: () => setConfirmEyeOpen(!confirmEyeOpen),
          formErrors // Pass form errors to show validation messages
        })}
        loading={loading}
        passFormData={handleFormDataChange} // Handle form data changes
        // isUpdateFormData={false} // Prevent form from resetting on re-render
      />

      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={saveBtnText.title}
        subTitle={saveBtnText.content}
        onClick={SubmitUser}
        save={saveBtnText.btnText}
        cancel={'Exit'}
        loading={loading}
      />
      
      <Notification 
        message={errorMessage} 
        setopen={setnotification} 
        type={'error'} 
        show={notification} 
      />
    </Box>
  );
};

